import styled from 'styled-components'

export const MainContainer = styled.div`
  display: grid;
  grid-template-areas: 'header header' 'alert alert' 'sidebar content';
  grid-template-columns: min-content 1fr;
  height: 100%;
  width: 100%;
`

export const HeaderContainer = styled.div`
  grid-area: header;
  position: sticky;
  background-color: white;
  z-index: 100;
`

export const AlertContainer = styled.div`
  grid-area: alert;
  position: relative;
  top: 65px;
  margin-bottom: ${props => props.theme.spacing.sp16};
  z-index: 1;
`

export const SideBarContainer = styled.div`
  top: 65px;
  position: fixed;
  grid-area: sidebar;
  z-index: 100;
  height: calc(100vh - 65px);
  border-right: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
`
export const ContentContainer = styled.div`
  grid-area: content;
  padding: ${props => props.theme.spacing.sp64};
  padding-left: 100px;
  min-height: 100vh;
  min-width: 0;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #f8fbfa, #e9f1ee);
  ${props =>
    props.showPattern &&
    `
    background-image: url('https://cdn.reveni.io/public/img/images/reveni-pattern.png');
    background-size: 350px 350px;
  `}
  z-index: 0;

  > div {
    max-width: 1529px;
    max-height: min-content;
  }
`
